import { TemplateElement, html, defineElement } from '@webtides/element-js';
import CurrencyFormatter from '../../../js/helper/currency-formatter';

class PriceFormatted extends TemplateElement {
    constructor() {
        super({ shadowRender: false });
    }

    properties() {
        return {
            cents: 0,
        };
    }

    get formattedPrice() {
        return CurrencyFormatter.formattedPrice(this.cents);
    }

    template() {
        return html`
            <span>${this.formattedPrice}</span>
        `;
    }
}

defineElement('price-formatted', PriceFormatted);
